export default "__VITE_PUBLIC_ASSET__fb42d7dd__"